var map = {
	"./battleJet.png": "e884",
	"./captainTroop.png": "cc0b",
	"./colonelTroop.png": "3ba5",
	"./corporalTroop.png": "9204",
	"./firstSergeantTroop.png": "ca2f",
	"./flag.png": "cd78",
	"./flyingJet.png": "8f28",
	"./generalTroop.png": "3e9c",
	"./groundBomb.png": "d04b",
	"./groundDefuserTroop.png": "13f5",
	"./lieutenantTroop.png": "4640",
	"./lifeboat.png": "8ea7",
	"./m4Ship.png": "e3f5",
	"./m7Ship.png": "f9e3",
	"./majorTroop.png": "b4db",
	"./marshallTroop.png": "bea7",
	"./seaBomb.png": "3d40",
	"./seaDefuserTroop.png": "14bc",
	"./sergeantTroop.png": "5614",
	"./spyBoat.png": "67fc",
	"./unknown.png": "5663"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6417";